import { StyleSheet, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width } = Dimensions.get('window');

export default StyleSheet.create({
  customOptionColorContainer: isActive => ({
    width: 26,
    height: 26,
    borderRadius: 13,
    marginBottom: 6,
    marginTop: isActive ? 0 : 2,
  }),
  optionStyle: (number, padding, theme) => {
    if (number > 3) {
      return {
        width: width * 0.28,
        height: 69,
        marginRight: 8,
        backgroundColor: theme.colors.backgroundColorFour,
      };
    }
    return {
      width: (width - padding * (number + 3)) / number,
      height: 69,
      marginRight: padding,
      backgroundColor: theme.colors.backgroundColorFour,
    };
  },
  groupContainer: { marginTop: 34 },
  groupTitle: { marginLeft: 16, marginBottom: 16, fontSize: 18 },
  OptionsContainer: {
    paddingLeft: 16,
    paddingRight: 8,
  },
  titleStyle: theme => ({
    color: theme.colors.text.primary,
    lineHeight: 16,
    marginTop: 5,
  }),
  subTitleStyle: theme => ({
    marginTop: 7,
    color: theme.colors.text.primary,
  }),
  customSubTitleStyle: isActive => ({
    ...(isActive ? Fonts.type.bold : { lineHeight: 18 }),
    fontSize: 14.6,
  }),
});
